import { useLocale } from "@/context/LocaleContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useLocale();
  return (
    <footer className="mt-12 border-t border-white/8 bg-transparent">
      <div className="container mx-auto py-8 text-sm text-white/70">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          <div>
            <div className="mb-2 font-semibold text-white">BuildStore</div>
            <div className="text-white/70">{t("footer.description")}</div>
          </div>
          <div>
            <div className="mb-2 font-semibold text-white">
              {t("contact.title")}
            </div>
            <div className="text-white/70">
              {t("footer.email")}:{" "}
              <a
                className="text-primary hover:underline"
                href="mailto:info@buildstore.it"
              >
                info@buildstore.it
              </a>
            </div>
            <div className="mt-3">
              <Link
                to="/contattaci"
                className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-colors text-xs"
              >
                {t("footer.contact_button")}
              </Link>
            </div>
          </div>
          <div>
            <div className="mb-2 font-semibold text-white">
              {t("footer.quick_links")}
            </div>
            <div className="flex flex-col gap-1">
              <a className="text-primary hover:underline" href="/">
                {t("footer.links.home")}
              </a>
              <a className="text-primary hover:underline" href="/products">
                {t("footer.links.products")}
              </a>
              <a className="text-primary hover:underline" href="/chi-siamo">
                {t("footer.links.about")}
              </a>
              <a className="text-primary hover:underline" href="/valore#faq">
                {t("footer.links.faq")}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-white/50">
          © {new Date().getFullYear()} BuildStore. {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
}
